export const API_URL = process.env.NODE_ENV === "production" ? "/api" : "/api";

export const CACHE_API_TIME = {
  FETCH_CURRENCIES: 360
};

export const API_TIMEOUT = 30000;
